
<template>
  <div>
    <div class="flex flex-wrap-reverse items-center flex-grow justify-between my-4">
      <div class="flex flex-wrap-reverse items-center data-list-btn-container">
      </div>
      <div>
        <div class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <div class="flex flex-wrap-reverse">

            <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4">
              <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center w-full">
                <span class="mr-2">Rekap Pekerjaan</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>

                <vs-dropdown-item :to="{path:`/proyek/rekap/pekerjaan_divisi/${routeId}`}">
                  <span class="flex items-center text-lg font-medium w-32">
                    <span>Divisi</span>
                  </span>
                </vs-dropdown-item>

                <vs-dropdown-item :to="{path:`/proyek/rekap/pekerjaan_kelompok/${routeId}`}">
                  <span class="flex items-center text-lg font-medium w-32">
                    <span>Kelompok</span>
                  </span>
                </vs-dropdown-item>

                <vs-dropdown-item :to="{path:`/proyek/rekap/pekerjaan_sub/${routeId}`}">
                  <span class="flex items-center text-lg font-medium w-32">
                    <span>Sub</span>
                  </span>
                </vs-dropdown-item>

              </vs-dropdown-menu>
            </vs-dropdown>

            <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4">

              <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center w-full">
                <span class="mr-2">Rekap Kebutuhan</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>

              <vs-dropdown-menu>

                <vs-dropdown-item :to="{path:`/proyek/kebutuhan/tenaga/${routeId}`}">
                  <span class="flex items-center text-lg font-medium w-32">
                    <feather-icon icon="UsersIcon" svgClasses="h-4 w-4" class="mr-2" />
                    <span>Tenaga</span>
                  </span>
                </vs-dropdown-item>

                <vs-dropdown-item :to="{path:`/proyek/kebutuhan/bahan/${routeId}`}">
                  <span class="flex items-center text-lg font-medium w-32">
                    <feather-icon icon="DropletIcon" svgClasses="h-4 w-4" class="mr-2" />
                    <span>Bahan</span>
                  </span>
                </vs-dropdown-item>

                <vs-dropdown-item :to="{path:`/proyek/kebutuhan/alat/${routeId}`}">
                  <span class="flex items-center text-lg font-medium w-32">
                    <feather-icon icon="ZapIcon" svgClasses="h-4 w-4" class="mr-2" />
                    <span>Alat</span>
                  </span>
                </vs-dropdown-item>

              </vs-dropdown-menu>
            </vs-dropdown>

            <vs-button color="primary" icon-pack="feather" icon="icon-calendar" :to="{path:`/proyek/jadwal/${routeId}`}">Schedule</vs-button>
          </div>
        </div>
      </div>
    </div>
    <vs-row>
      <vs-col vs-w="12">
        <div id="pekerjaan-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">

          <vs-sidebar class="items-no-padding" parent="#pekerjaan-app" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isPekerjaanSidebarActive">
            <pekerjaan-sidebar @closeSidebar="togglePekerjaanSidebar" :pekerjaanFilter="pekerjaanFilter" :pekerjaanTags="pekerjaanTags"/>
          </vs-sidebar>

          <vs-popup class="email-compose" title="Filter" :active.sync="activeFilter">
              <component :is="scrollbarTag" class="scroll-area p-4" :settings="settings" :key="$vs.rtl">

                <vs-select
                  class="w-full mt-2"
                  v-model="dataBidang"
                  @change="pilihDivisi"
                  @click.prevent="changeClickDivisi"
                  >
                    <vs-select-item value="empty" text="Bidang"/>
                    <vs-select-item :key="itemx.id" :value="itemx.id" :text="`${itemx.kode}. ${itemx.name}`" v-for="itemx in listBidang"/>
                </vs-select>

                <vs-select
                  class="w-full mt-4"
                  v-model="dataDivisi"
                  @change="pilihKelompok"
                  @click.prevent="changeClickKelompok"
                  >
                    <vs-select-item value="empty" text="Divisi"/>
                    <vs-select-item :key="itemx.id" :value="itemx.id" :text="`${itemx.kode} ${itemx.name}`" v-for="itemx in listDivisi"/>
                </vs-select>

                <vs-select
                  class="w-full mt-4"
                  v-model="dataKelompok"
                  @change="pilihSub"
                  @click.prevent="changeClickSub"
                  >
                    <vs-select-item value="empty" text="Kelompok"/>
                    <vs-select-item :key="itemx.id" :value="itemx.id" :text="`${itemx.kode} ${itemx.name}`" v-for="itemx in listKelompok"/>
                </vs-select>

                <vs-select
                  class="w-full mt-4"
                  v-model="dataSub"
                  >
                    <vs-select-item value="empty" text="Sub"/>
                    <vs-select-item :key="itemx.id" :value="itemx.id" :text="`${itemx.kode} ${itemx.name}`" v-for="itemx in listSub"/>
                </vs-select>
                <vs-button class="mt-4 w-full" @click="paramData" :disabled="!isFilterValid">Submit</vs-button>
              </component>
          </vs-popup>

          <div class="no-scroll-content border border-solid d-theme-border-grey-light border-r-0 border-t-0 border-b-0" :class="{'sidebar-spacer': clickNotClose}">
            <!--
            <template v-if="routeFilter != 'default'">
            -->

              <div class="flex border d-theme-dark-bg items-center">
                <feather-icon class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer" icon="MenuIcon" @click.stop="togglePekerjaanSidebar(true)"/>
                <vs-input icon-no-border icon="icon-search" icon-pack="feather" placeholder="Search Pekerjaan" v-model="search" class="vs-input-no-border vs-input-no-shdow-focus w-full" v-on:keyup.enter="paramData()"/>
              </div>

              <div class="pekerjaan__actions flex items-center flex-wrap justify-between p-4 border border-r-0 border-l-0 border-solid d-theme-border-grey-light" v-if="taxonomy != 'trash'">
                <div class="flex">
                  <vs-checkbox v-model="selectAllCheckBox" icon-pack="feather" :icon="selectAllIcon" class="vs-checkbox-small select-all-chexkbox ml-0">Pilih</vs-checkbox>
                </div>
                <div class="flex">
                    <vs-button color="dark" class="btnx" type="filled" size="small">{{ pekerjaanCurrentPage }}  /  {{ pekerjaanTotalPage }}</vs-button>

                    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                      <vs-button color="dark" class="btn-drop" type="filled" icon="expand_more" size="small"></vs-button>
                      <vs-dropdown-menu>
                        <vs-dropdown-item v-for="p in pekerjaanPage" :key="p" @click.stop="nextData(p)" :disabled="p === pekerjaanCurrentPage">
                          {{ p }}
                        </vs-dropdown-item>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <div class="flex">

                  <feather-icon icon="TrashIcon" svgClasses="h-6 w-6" class="" @click="removesPekerjaan" v-if="selectedPekerjaans.length > 0"/>
                  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer" v-if="selectedPekerjaans.length > 0">
                    <feather-icon icon="TagIcon" class="cursor-pointer ml-5 pt-1" svg-classes="h-6 w-6"></feather-icon>
                    <vs-dropdown-menu >
                      <vs-dropdown-item v-for="(tag, index) in pekerjaanTags" :key="index" @click="updateLabels(tag.id)" class="whitespace-no-wrap">
                        <vs-chip :color="tag.color" class="mr-2 mt-1" style="min-height:10px;min-width:10px;"></vs-chip>
                        <span>{{ tag.name }}</span>
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                  <feather-icon icon="FilterIcon" class="cursor-pointer ml-5" svg-classes="h-6 w-6" @click="activeFilter = true"/>
                  <feather-icon icon="PlusIcon" class="cursor-pointer ml-5" svg-classes="h-6 w-6" @click="addPekerjaan" v-can="'A'"/>
                </div>
              </div>

              <component :is="scrollbarTag" class="pekerjaan-content-scroll-area" :settings="settings" ref="pekerjaanListPS" :key="$vs.rtl">
                <transition-group name="list-enter-up" class="pekerjaan__pekerjaans" tag="ul" appear>
                  <li class="cursor-pointer pekerjaan__pekerjaan-item" v-for="(pekerjaan, index) in pekerjaans" :key="String(pekerjaanFilter) + String(pekerjaan.id)" :style="{transitionDelay: (index * 0.1) + 's'}">
                    <pekerjaan-item 
                      :pekerjaan="pekerjaan" 
                      :isSelected="isPekerjaanSelected(pekerjaan.id)" 
                      @addToSelected="addToSelectedPekerjaans" 
                      @removeSelected="removeSelectedPekerjaan"
                      @updateOpenPekerjaan="updatePekerjaan" 
                    />
                  </li>
                </transition-group>
              </component>
            <!--
            </template>

            <template v-else>
              <div class="flex flex-col items-center">
                <component :is="scrollbarTag" class="pekerjaan-content-scroll-area" :settings="settings" ref="pekerjaanListPS" :key="$vs.rtl">
                </component>
                <feather-icon icon="EditIcon" class="mb-4 bg-white p-8 shadow-md rounded-full" svgClasses="w-16 h-16"></feather-icon>
                <h4 class=" py-2 px-4 bg-white shadow-md rounded-full cursor-pointer" @click.stop="togglePekerjaanSidebar(true)">Mulai Merencanakan Pekerjaan </h4>
              </div>
            </template>
            -->
          </div>

          <pekerjaan-view
              :pekerjaanTags    = "pekerjaanTags"
              :openPekerjaanId  = "openPekerjaanId"
              :data             = "dataPekerjaan"
              :isSidebarActive  = "isSidebarActive"
              :pekerjaanFilter  = "pekerjaanFilter"
              :listBidang       = "listBidang"
              :Taxonomy         = "taxonomy"
              :RABs             = "rab"
              :totalPekerjaan   = "pekerjaanTotalSatu"
              @markUnread       = "updateSingleMarkUnread"
              @removePekerjaan  = "removeOpenPekerjaan"
              @putbackPekerjaan = "putbackOpenPekerjaan"
              @previousPekerjaan= "previousPekerjaan"
              @nextPekerjaan    = "nextPekerjaan"
              @moveTo           = "moveCurrentTo"
              @closeSidebar     = "closePekerjaanViewSidebar">
          </pekerjaan-view>
        </div>
      </vs-col>
    </vs-row>
  </div>
</template>
<script>
import PekerjaanSidebar    from './PekerjaanSidebar.vue'
import PekerjaanItem       from './PekerjaanItem.vue'
import PekerjaanView       from './PekerjaanView.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import modulePekerjaan     from '@/stores/proyek/pekerjaan/perencanaan/modulePerencanaan.js'
import { mapGetters } from 'vuex'
import moduleSubkontraktor from '@/stores/term/kontak.js'
export default {
  data () {
    return {
      activeFilter         : false,

      dataBidang: 'empty',
      changeBidang: false,
      dataDivisi: 'empty',
      changeDivisi: false,
      dataKelompok: 'empty',
      changeKelompok: false,
      dataSub: 'empty',
      changeSub: false,
      listBidang: [],
      listSub: [],
      listDivisi: [],
      listKelompok: [],

      openPekerjaanId      : null,
      dataPekerjaan        : {},
      selectedPekerjaans   : [],
      activeChatUser       : null,
      isSidebarActive      : false,
      showThread           : false,
      clickNotClose        : true,
      isPekerjaanSidebarActive : true,
      settings             : {
        maxScrollbarLength : 60,
        wheelSpeed         : 0.30
      },
      search : null
    }
  },
  watch: {
    isSidebarActive (value) {
      if (!value) this.showThread = false
    },
    pekerjaanFilter () {
      this.selectedPekerjaans = []

      const scroll_el = this.$refs.pekerjaanListPS.$el || this.$refs.pekerjaanListPS
      scroll_el.scrollTop = 0

      const obj = {
        action: 'create',
        anggaran: this.$route.params.id,
        search: this.search,
        filter: this.$route.params.filter,
        sub : 'empty',
        kelompok : 'empty',
        divisi : 'empty',
        bidang : 'empty'
      }

      this.$store.commit('pekerjaan/UPDATE_PEKERJAAN_FILTER', obj)
      this.$store.dispatch('pekerjaan/fetchPekerjaans', obj)
      this.togglePekerjaanSidebar()
    },
    windowWidth () {
      this.setSidebarWidth()
    }
  },
  computed: {
    pekerjaanFilter () {
      return this.$route.params.filter
    },
    routeId () {
      return this.$route.params.id
    },
    routeFilter () {
      return this.$route.params.filter
    },
    pekerjaanTags () {
      return this.$store.state.pekerjaan.pekerjaanTags
    },
    searchQuery: {
      get () {
        return this.$store.state.pekerjaan.pekerjaanSearchQuery
      },
      set (val) {
        this.$store.dispatch('pekerjaan/setPekerjaanSearchQuery', val)
      }
    },
    selectAllCheckBox: {
      get () {
        return this.selectedPekerjaans.length
      },
      set (value) {
        value ? this.selectedPekerjaans = this.pekerjaans.map(pekerjaan => pekerjaan.id) : this.selectedPekerjaans = []
      }
    },
    pekerjaans () {
      /*
      return this.$store.getters['pekerjaan/filteredPekerjaans']
      */
      return this.$store.state.pekerjaan.pekerjaans
    },
    pekerjaanTotal () {
      return this.$store.state.pekerjaan.total
    },
    pekerjaanTotalSatu () {
      return this.$store.state.pekerjaan.total + 1
    },
    pekerjaanLast () {
      return this.$store.state.pekerjaan.last
    },
    pekerjaanPerPage () {
      return this.$store.state.pekerjaan.per_page
    },
    pekerjaanCurrentPage () {
      return this.$store.state.pekerjaan.current_page
    },
    pekerjaanPage () {
      const page = []
      const number = this.$store.state.pekerjaan.total / this.$store.state.pekerjaan.per_page
      var i
      for (i=0; i < number; i++) {
        page.push(i+1)
      }
      return page
    },
    pekerjaanTotalPage () {
      let number = this.$store.state.pekerjaan.total / this.$store.state.pekerjaan.per_page
      if (number < 1) {
        number = 1
      }
      return Math.ceil(number)
    },
    taxonomy () {
      return this.$store.state.pekerjaan.taxonomy
    },
    rab () {
      return this.$store.state.pekerjaan.rab
    },
    filters () {
      return this.$store.state.pekerjaan.filters
    },
    selectAllIcon () {
      return this.selectedPekerjaans.length === this.pekerjaans.length ? 'icon-check' : 'icon-minus'
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    isPekerjaanSelected () {
      return (pekerjaanId) => this.selectedPekerjaans.indexOf(pekerjaanId) !== -1
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },
    ...mapGetters({
      user : 'auth/user',
    }),
    isFilterValid () {
      return this.dataBidang != 'empty'
    }
  },
  methods: {
    /*
    updateOpenPekerjaan (pekerjaanId) {
      this.openPekerjaanId = pekerjaanId
      this.isSidebarActive = true
    },
    */
    changeClickDivisi () {
      this.changeDivisi = true
    },
    pilihDivisi () {
      this.listDivisi = []
      this.listKelompok = []
      this.listSub = []
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      if (this.dataBidang != 'empty') {
        this.axios.get('/term-parent/'+this.dataBidang, configs).then((response) => {
          let {data} = response.data
          this.listDivisi = data
        })
      }
      if (this.changeDivisi === true) {
        this.dataDivisi = 'empty'
        this.dataKelompok = 'empty'
        this.dataSub = 'empty'
      }
    },
    changeClickKelompok () {
      this.changeKelompok = true
    },
    pilihKelompok () {
      this.listKelompok = []
      this.listSub = []
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      if (this.dataDivisi != 'empty') {
        //this.dataKelompok = 'pilih'
        this.axios.get('/term-parent/'+this.dataDivisi, configs).then((response) => {
          let {data} = response.data
          this.listKelompok = data
        })
      }
      if (this.changeKelompok === true) {
        this.dataKelompok = 'empty'
        this.dataSub = 'empty'
      }
    },
    changeClickSub () {
      this.changeSub = true
    },
    pilihSub () {
      this.list_sub = []
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      if (this.dataKelompok != 'empty') {
        this.axios.get('/term-parent/'+this.dataKelompok, configs).then((response) => {
          let {data} = response.data
          this.listSub = data
        })
      }
      if (this.changeSub === true) {
        this.dataSub = 'empty'
      }
    },
    paramData () {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '.pekerjaan__pekerjaan-item',
        scale: 0.45
      })
      const obj = {
        action: 'create',
        anggaran: this.$route.params.id,
        search: this.search,
        filter: this.$route.params.filter,
        page: 1,
        sub : this.dataSub,
        divisi : this.dataDivisi,
        kelompok : this.dataKelompok,
        bidang : this.dataBidang
      }
      setTimeout(() => {
        this.$store.state.pekerjaan.pekerjaans = []
        this.$store.state.pekerjaan.total = null
        this.$store.state.pekerjaan.last = null
        //this.nextButton = true
        this.$store.dispatch('pekerjaan/fetchPekerjaans', obj)
        this.$vs.loading.close('.pekerjaan__pekerjaan-item > .con-vs-loading')
      }, 2000)
      this.activeFilter = false
    },
    nextData (page) {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '.pekerjaan__pekerjaan-item',
        scale: 0.45
      })
      const obj = {
        action: 'create',
        anggaran: this.$route.params.id,
        search: this.search,
        filter: this.$route.params.filter,
        page: page,
        sub : this.dataSub,
        divisi : this.dataDivisi,
        kelompok : this.dataKelompok,
        bidang : this.dataBidang
      }
      setTimeout(() => {
        this.$store.state.pekerjaan.pekerjaans = []
        //this.nextButton = true
        this.$store.dispatch('pekerjaan/fetchPekerjaans', obj)
        this.$vs.loading.close('.pekerjaan__pekerjaan-item > .con-vs-loading')
      }, 2000)
      this.activeFilter = false
    },
    getNumbers (start,stop) {
      return new Array(stop-start).fill(start).map((n,i)=>n+i);
    },
    addPekerjaan () {
      this.dataPekerjaan = {}
      this.isSidebarActive = true
    },
    updatePekerjaan (pekerjaan) {
      this.openPekerjaanId = pekerjaan.id
      this.dataPekerjaan = pekerjaan
      this.isSidebarActive = true
    },
    addToSelectedPekerjaans (pekerjaanId) {
      if (this.selectedPekerjaans.indexOf(pekerjaanId) === -1) this.selectedPekerjaans.push(pekerjaanId)
    },
    removeSelectedPekerjaan (pekerjaanId) {
      const pekerjaanIndex = this.selectedPekerjaans.indexOf(pekerjaanId)
      if (pekerjaanIndex !== -1) this.selectedPekerjaans.splice(pekerjaanIndex, 1)
    },
    moveTo (to) {
      const payload = { pekerjaanIds: this.selectedPekerjaans, to }
      this.$store.dispatch('pekerjaan/movePekerjaanTo', payload)
        .catch((error) => { 
          this.$vs.notify({
            title: 'Error',
            text: error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
      this.selectedPekerjaans = []
    },
    moveCurrentTo (to) {
      this.selectedPekerjaans = [this.openPekerjaanId]
      this.moveTo(to)
    },
    removeOpenPekerjaan () {
      this.$store.dispatch('pekerjaan/deletePekerjaan', this.openPekerjaanId)
        .catch((error) => { 
          this.$vs.notify({
            title: 'Error',
            text: error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
      this.isSidebarActive = false
    },
    removesPekerjaan () {
      this.$store.dispatch('pekerjaan/deletesPekerjaan', { pekerjaans: this.selectedPekerjaans })
      this.selectedPekerjaans = []
    },
    putbackOpenPekerjaan () {
      const obj = {
        pekerjaanId : this.openPekerjaanId
      }
      this.$store.dispatch('pekerjaan/putbackPekerjaan', obj)
        .catch((error) => { 
          this.$vs.notify({
            title: 'Error',
            text: error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
      this.isSidebarActive = false
    },
    nextPekerjaan () {
      const currentPekerjaanIndex = this.pekerjaans.findIndex((pekerjaan) => pekerjaan.id === this.openPekerjaanId)
      if (this.pekerjaans[currentPekerjaanIndex + 1]) {
        this.openPekerjaanId = this.pekerjaans[currentPekerjaanIndex + 1].id
      } else {
        this.$vs.notify({
          text: 'Tidak ada data setelahnya',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },
    previousPekerjaan () {
      const currentPekerjaanIndex = this.pekerjaans.findIndex((pekerjaan) => pekerjaan.id === this.openPekerjaanId)
      if (this.pekerjaans[currentPekerjaanIndex - 1]) {
        this.openPekerjaanId = this.pekerjaans[currentPekerjaanIndex - 1].id
      } else {
        this.$vs.notify({
          text: 'Tidak ada data sebelumnya',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },
    updateSingleMarkUnread () {
      this.selectedPekerjaans = [this.openPekerjaanId]
      this.updateMarkUnread()
      this.isSidebarActive = false
    },
    updateLabels (label) {
      this.$store.dispatch('pekerjaan/updateLabels', { pekerjaans: this.selectedPekerjaans, label })
      this.selectedPekerjaans = []
    },
    closePekerjaanViewSidebar () {
      this.isSidebarActive = false
    },
    setSidebarWidth () {
      if (this.windowWidth < 992) {
        this.isPekerjaanSidebarActive = this.clickNotClose = false
      } else {
        this.isPekerjaanSidebarActive = this.clickNotClose = true
      }
    },
    togglePekerjaanSidebar (value = false) {
      if (!value) {
        this.closePekerjaanViewSidebar()
        if (this.clickNotClose) {
          return
        }
      }
      this.isPekerjaanSidebarActive = value
    }
  },
  components: {
    PekerjaanItem,
    PekerjaanSidebar,
    PekerjaanView,
    VuePerfectScrollbar
  },
  created () {
    this.$store.registerModule('pekerjaan', modulePekerjaan)
    this.$store.registerModule('subkontraktor', moduleSubkontraktor)
    this.setSidebarWidth()

    let configs = {
      headers: {
        'Authorization': 'Bearer ' + this.user.api_token,
      },
    }
    this.axios.get('/term-list/pekerjaan_bidang', configs).then((response) => {
      let {data} = response.data
      this.listBidang = data
    })

    const obj = {
      action: 'create',
      anggaran: this.$route.params.id,
      search: this.search,
      filter: this.$route.params.filter,
      page: 1,
      sub : 'empty',
      kelompok : 'empty',
      divisi : 'empty',
      bidang : 'empty'
    }

    this.$store.commit('pekerjaan/UPDATE_PEKERJAAN_FILTER', obj)
    this.$store.dispatch('pekerjaan/fetchPekerjaans', obj)
    this.$store.dispatch('pekerjaan/fetchFilters', this.$route.params.id)
    this.$store.dispatch('pekerjaan/fetchTags', this.$route.params.id)
    this.$store.dispatch('subkontraktor/fetchKontakGroupTaxonomySlug', 'subkontraktor')
  },
  beforeDestroy () {
    this.$store.unregisterModule('pekerjaan')
  },
  mounted () {
    this.$store.dispatch('pekerjaan/setPekerjaanSearchQuery', '')
    this.$store.commit('TOGGLE_REDUCE_BUTTON', false)
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/vuexy/apps/pekerjaan.scss";
.btnx {
  border-radius: 5px 0px 0px 5px;
}
.btn-drop {
  border-radius: 0px 5px 5px 0px;
  border-left: 1px solid rgba(255, 255, 255, .2);
}
</style>
